import styled from 'styled-components'
import { Link } from 'gatsby'
import { LocalizedLink } from 'gatsby-plugin-i18n-l10n'

import breakpoints from '../../constants/ui/breakpoints'
import { BUTTON_HEIGHT, BUTTON_SMALL_HEIGHT } from '../../constants/ui/elements'

export const LinkStyled = styled.a`
  text-decoration: underline;
  color: ${({ theme }) => theme.textHighlight};
  font-weight: 500;

  :hover {
    opacity: 0.6;
  }
`

const LinkAsButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  line-height: 1;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  text-align: center;
  border: 0;
  border-radius: 2rem;
  padding: 0 2.5rem;
  height: ${({ small }) => (small ? BUTTON_SMALL_HEIGHT : BUTTON_HEIGHT)};
  opacity: ${({ isDisabled }) => (isDisabled ? '0.6' : '1')};
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'all')};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};

  @media (max-width: ${breakpoints.screenSM}) {
    padding: 0 1.5rem;
    min-width: 90%;
  }
`

export const LinkAsButtonPrimary = styled(LinkAsButton)`
  color: ${({ theme }) => theme.textLight};
  background-color: ${({ theme }) => theme.buttonPrimary};

  :hover {
    opacity: ${({ isDisabled }) => (isDisabled ? '0.6' : '0.8')};
  }
`

export const LinkAsButtonSecondary = styled(LinkAsButton)`
  color: ${({ theme }) => theme.textHighlight};
  background-color: ${({ theme }) => theme.buttonSecondary};

  :hover {
    opacity: ${({ isDisabled }) => (isDisabled ? '0.6' : '0.8')};
  }
`

export const LinkGatsbydStyled = styled(Link)`
  text-decoration: underline;
  color: ${({ theme }) => theme.textHighlight};
  font-weight: 500;

  :hover {
    opacity: 0.6;
  }
`

const LinkAsButtonGatsby = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  line-height: 1;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  text-align: center;
  border: 0;
  border-radius: 2rem;
  padding: 0 2.5rem;
  height: ${({ small }) => (small ? BUTTON_SMALL_HEIGHT : BUTTON_HEIGHT)};
  opacity: ${({ isDisabled }) => (isDisabled ? '0.6' : '1')};
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'all')};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};

  @media (max-width: ${breakpoints.screenSM}) {
    padding: 0 1.5rem;
    min-width: 90%;
  }
`

export const LinkAsButtonGatsbyPrimary = styled(LinkAsButtonGatsby)`
  color: ${({ theme }) => theme.textLight};
  background-color: ${({ theme }) => theme.buttonPrimary};

  :hover {
    opacity: ${({ isDisabled }) => (isDisabled ? '0.6' : '0.8')};
  }
`

export const LinkAsButtonGatsbySecondary = styled(LinkAsButtonGatsby)`
  color: ${({ theme }) => theme.textHighlight};
  background-color: ${({ theme }) => theme.buttonSecondary};

  :hover {
    opacity: ${({ isDisabled }) => (isDisabled ? '0.6' : '0.8')};
  }
`

export const LinkLocalizedStyled = styled(LocalizedLink)`
  text-decoration: underline;
  color: ${({ theme }) => theme.textHighlight};
  font-weight: 500;

  :hover {
    opacity: 0.6;
  }
`

const LinkAsButtonLocalized = styled(LocalizedLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  line-height: 1;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  text-align: center;
  border: 0;
  border-radius: 2rem;
  padding: 0 2.5rem;
  height: ${({ small }) => (small ? BUTTON_SMALL_HEIGHT : BUTTON_HEIGHT)};
  opacity: ${({ isDisabled }) => (isDisabled ? '0.6' : '1')};
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'all')};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};

  @media (max-width: ${breakpoints.screenSM}) {
    padding: 0 1.5rem;
    min-width: 90%;
  }
`

export const LinkAsButtonLocalizedPrimary = styled(LinkAsButtonLocalized)`
  color: ${({ theme }) => theme.textLight};
  background-color: ${({ theme }) => theme.buttonPrimary};

  :hover {
    opacity: ${({ isDisabled }) => (isDisabled ? '0.6' : '0.8')};
  }
`

export const LinkAsButtonLocalizedSecondary = styled(LinkAsButtonLocalized)`
  color: ${({ theme }) => theme.textHighlight};
  background-color: ${({ theme }) => theme.buttonSecondary};

  :hover {
    opacity: ${({ isDisabled }) => (isDisabled ? '0.6' : '0.8')};
  }
`
